import { useCallback } from 'react';
import { useBlocker, useParams } from 'react-router-dom';

import { queryClient } from '@webclient/providers/ReactQueryProvider';

import useAppDispatch from '@webclient/hooks/useAppDispatch';

import { stopVoiceChatMode } from '@webclient/state/slices/search-session';
import disconnectFromRoom from '@webclient/state/slices/search-session/thunks/disconnectAsyncRoom';

export default function useResetThreadOnExit() {
  const { id: threadId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const handleExistVoiceModeChat = useCallback(async () => {
    await queryClient.invalidateQueries({
      exact: false,
      queryKey: ['historyBlocks', threadId],
    });
    dispatch(stopVoiceChatMode());
  }, [dispatch, threadId]);

  useBlocker(({ currentLocation, historyAction }) => {
    if (
      currentLocation.pathname.includes('/app/search') &&
      (historyAction === 'POP' || historyAction === 'PUSH')
    ) {
      handleExistVoiceModeChat();
      dispatch(disconnectFromRoom());
    }
    return false;
  });

  return {
    handleExistVoiceModeChat,
  };
}
